import { object, string } from 'yup';
export const photoSubmissionSchema = object({
    assignmentPublicId: string().required(),
    submittedVia: string().oneOf(['telegram', 'whatsapp', 'in_person', 'staff_upload', 'other']).required(),
    notes: string().optional(),
});
